import React from "react";
import { MessageType } from "../../constants";
import { formateDateTime } from '../../utils';
import FileIcon from "../../static/images/icon-file.svg";
import DownloadIcon from "../../static/images/icon-download.svg";


function JsonTemplate({ message, regenDoc }) {
    const content = JSON.parse((message.content))
    return (
        <>
            {content.type.toLowerCase() === MessageType.document ?
                <div className="grop_message">
                    <div onClick={() => regenDoc(content.document.docId)} className="download-policy-message message">
                        <div className="download-policy">
                            <img src={FileIcon} className="icon-file" alt="" /><p>Document</p><img src={DownloadIcon} className="icon-download" alt="" />
                        </div>

                    </div>
                </div>
                : null}
            {content.type && content.type.toLowerCase() === "selection" ?
                < div className="grop_message">
                    <div className="message" >{content.display_value} </div>
                </div>
                : null}
            {content.type && content.type.toLowerCase() === "plan_multi_selection" ?
                < div className="grop_message">
                    <div className="message" >
                        {content.plan ? content.plan.map((item, i) => <>
                            {i > 0 && "&  "} {item.plan_name}{" "}
                        </>
                        ) : null}  </div>
                </div>
                : null}
            {content.type && content.type.toLowerCase() === "plan_selection" ?

                < div className="grop_message">
                    <div className="message" >
                        {content.plan ? content.plan.map((item, i) => <>
                            {i > 0 && "&  "} {item.plan_name}{" "}
                        </>
                        ) : null}  </div>
                </div>

                : null}

        </>
    )
}


export default function TravelCustomerMessage({ messages, regenDoc }) {
    return (
        <li className="me">
            {messages.map((item) => (
                <>
                    {
                        item.type === 'json' ?
                            <JsonTemplate regenDoc={regenDoc} message={item} ></JsonTemplate>
                            :
                            <div className="grop_message">
                                <div className="message"> {item.content} </div>
                            </div>
                    }
                </>
            ))}
            <div className="entete">
                <h3>{formateDateTime(messages[messages.length - 1].sentAt)}</h3>
            </div>

        </li>

    );
}
